import universal from 'react-universal-component';

export default universal(() => import('./ConnectedEmailPreferences'));



// WEBPACK FOOTER //
// ./src/app/views/EmailPreferences/index.js